import axios from './axiosInstances/axiosInstance';

// const STATUS = ['Pending', 'DeliveryInProgress', 'Delivered'];

export const checkOrderDeliveryStatus = (orderId) => {
  return axios.get(`/orders/${orderId}/deliveryStatus`);
};
